import SendPripomienkyPage from './SendPripomienkyPage';

export default SendPripomienkyPage;
